import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import locales from '../utils/locales'
import { withI18n } from '@lingui/react'

const LocalizedLink = ({ to, i18n: { _language: locale }, ...props }) => (
  <Link {...props} to={locales[locale].default ? to : locale + to} />
)

LocalizedLink.propTypes = {
  to: PropTypes.string.isRequired,
}

export default withI18n()(LocalizedLink)
